import * as Constants from "../Canvas/Constants";
import { BrushingDataSet, brushingDataset } from "../../Globals/Globals";
import * as aggregation from "../aggregation/countAggregation";
import { HscatterPlotElements } from '../Brushing/HistogramBrushElements'
import {removeBrushElements, LineChartResizeYAxis, parallelCoordinatesBrushElements, histogramBrushElements, findMaxForBarChart, lineChartBrushElements, scatterPlotElements} from '../Brushing/BrushingElements'
import { element } from "prop-types";
import * as d3 from "d3";
import { PREDICTION_COLOR, REALDATA_COLOR, BRUSHING_COLOR, NO_PREDICTION_COLOR,  } from '../../Globals/ColorConstants'


export function barChartBrush(ggraphbrushEnable, barChartId, brushingPointsBarChartArray, brushingDataset: BrushingDataSet) {
    if (ggraphbrushEnable == 0 || ggraphbrushEnable == 1) {
        var datasetwise = aggregation.allValues
        var categorywise = Array.from(brushingPointsBarChartArray)
        var datasetwise = aggregation.allValues
        var actualDataset = brushingDataset.getActualMap().get(barChartId)
        var datasetIds=[];
        for (var entry in datasetwise)
        {
            var dataRecord = datasetwise[entry]
            var category = dataRecord[actualDataset.xaxis]
             if(categorywise.includes(category))
            {
                datasetIds.push(dataRecord["ID"])
            }
        }

        removeBrushElements(barChartId)
        brushingDataset.getActualMap().forEach(function(datasetValue, datasetKey, map) {
        
            if (datasetKey != barChartId) {

                if (datasetValue.type == Constants.SCATTERPLOT_CHART)
                {   
                    scatterPlotElements([],datasetKey)
                                      
                    scatterPlotElements(datasetIds,datasetKey)
                    
                }
                else if (datasetValue.type == Constants.HISTOGRAM_CHART)
                {
                        
                    histogramBrushElements(datasetValue.xaxis,datasetKey, datasetIds, datasetValue)       

                }
                else if (datasetValue.type == Constants.BAR_CHART)
                {   
                

                    var maxValue = findMaxForBarChart(datasetIds, 
                        datasetValue.linearXScale, 
                        datasetValue.linearYScale, 
                        datasetValue.xaxis, 
                        datasetValue.yaxis,
                        datasetValue, datasetKey)
                    console.log('maxValuebrushingPointsHistogramArray',maxValue)   
                        
                    
                    
                }
                else if (datasetValue.type == Constants.LINE_CHART) {

                                     
                    lineChartBrushElements(datasetIds, datasetKey, datasetValue) 
                }
                else if (datasetValue.type == Constants.PARALLEL_COORDINATES_CHART) {

                    parallelCoordinatesBrushElements(datasetIds, datasetKey, datasetValue) 

                    
                }
            }


        });
    }
    else {

        removeBrushElements(barChartId)
    }
}